var _style, _defs, _defs2, _rect, _defs3, _defs4, _rect2, _defs5, _defs6, _rect3, _defs7, _defs8, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.07 60.88",
    style: {
      enableBackground: "new 0 0 57.07 60.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#BFBFBF;}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);fill:#BFBFBF;}\n\t.st4{clip-path:url(#SVGID_10_);}\n\t.st5{clip-path:url(#SVGID_12_);fill:#BFBFBF;}\n\t.st6{clip-path:url(#SVGID_14_);}\n\t.st7{clip-path:url(#SVGID_16_);fill:#BFBFBF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M35.49,48.24c-0.23,0-0.46-0.03-0.69-0.09l-21.03-5.64c-1.44-0.4-2.3-1.89-1.92-3.33l2.65-9.9 c0.1-0.36,0.47-0.57,0.83-0.48c0.36,0.1,0.58,0.47,0.48,0.83l-2.65,9.89c-0.19,0.72,0.24,1.47,0.97,1.67l21.03,5.63 c0.72,0.19,1.47-0.24,1.66-0.96l1.06-3.94c0.1-0.36,0.47-0.58,0.83-0.48c0.36,0.1,0.58,0.47,0.48,0.83l-1.06,3.93 C37.79,47.44,36.69,48.24,35.49,48.24z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -436.25,
    y: -643.76,
    width: 1440,
    height: 1750
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.46,
    y: 27.71,
    className: "st1",
    width: 29.81,
    height: 21.53
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M20.14,19.61c-0.76,0-1.37,0.61-1.37,1.37V37.4c0,0.75,0.62,1.37,1.37,1.37H42.1 c0.76,0,1.37-0.61,1.37-1.37V20.98c0-0.75-0.62-1.37-1.37-1.37H20.14z M42.1,40.14H20.14c-1.51,0-2.75-1.23-2.75-2.74V20.98 c0-1.51,1.23-2.74,2.75-2.74H42.1c1.51,0,2.75,1.23,2.75,2.74V37.4C44.85,38.91,43.62,40.14,42.1,40.14z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -436.25,
    y: -643.76,
    width: 1440,
    height: 1750
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 17.24,
    className: "st3",
    width: 29.45,
    height: 23.89
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M24.26,23.72c-0.78,0-1.41,0.64-1.41,1.42c0,0.78,0.63,1.42,1.41,1.42c0.78,0,1.41-0.64,1.41-1.42 C25.67,24.35,25.04,23.72,24.26,23.72z M24.26,27.97c-1.56,0-2.83-1.27-2.83-2.84c0-1.57,1.27-2.84,2.83-2.84 c1.56,0,2.83,1.27,2.83,2.84C27.09,26.7,25.82,27.97,24.26,27.97z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -436.25,
    y: -643.76,
    width: 1440,
    height: 1750
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.43,
    y: 21.3,
    className: "st5",
    width: 7.65,
    height: 7.68
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M18.09,38.51c-0.18,0-0.35-0.07-0.49-0.2c-0.27-0.27-0.27-0.71,0-0.98l6.51-6.53 c0.78-0.78,2.14-0.78,2.92,0l1.94,1.94l5.36-6.46c0.39-0.47,0.96-0.74,1.57-0.75h0.02c0.6,0,1.17,0.26,1.57,0.72l7.2,8.44 c0.25,0.29,0.21,0.73-0.07,0.98c-0.29,0.25-0.72,0.22-0.97-0.07l-7.2-8.44c-0.13-0.15-0.32-0.24-0.52-0.24 c-0.14-0.01-0.4,0.09-0.53,0.25l-5.84,7.04c-0.12,0.15-0.3,0.24-0.5,0.25c-0.2,0.01-0.38-0.06-0.52-0.2l-2.47-2.48 c-0.26-0.26-0.71-0.26-0.97,0l-6.51,6.53C18.44,38.45,18.26,38.51,18.09,38.51z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -436.25,
    y: -643.76,
    width: 1440,
    height: 1750
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 24.54,
    className: "st7",
    width: 29.6,
    height: 14.97
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconGrey);
export default __webpack_public_path__ + "static/media/mediaIconGrey.714ecf1390633869122fde3cfce61ea9.svg";
export { ForwardRef as ReactComponent };